import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { Project } from "app/interfaces/project";
import { ProjectsService } from "app/services/projects.service";

@Component({
	selector: "app-logistics-ind",
	templateUrl: "./logistics-ind.component.html",
	styleUrls: ["./logistics-ind.component.scss"],
})
export class LogisticsIndComponent implements OnInit, OnChanges {
	logisticsProjs: Project[] = [];

	@Input() keywords : string = null;

	constructor(private projectsService: ProjectsService) {}

	ngOnInit() {
		this.getProjects();
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.getProjects();
	}

	getProjects(): void {
		this.logisticsProjs = this.projectsService.getLogistics(this.keywords);
	}

	getImage(a : any){
		return a.attach[0].src || a.attach[0];
	}

}
